import { render, staticRenderFns } from "./StoryBoardViewer.vue?vue&type=template&id=2320b99c&scoped=true"
import script from "./StoryBoardViewer.vue?vue&type=script&lang=js"
export * from "./StoryBoardViewer.vue?vue&type=script&lang=js"
import style0 from "./StoryBoardViewer.vue?vue&type=style&index=0&id=2320b99c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2320b99c",
  null
  
)

export default component.exports